import { fluid } from '@helpers/fluid';
import { Device, from, until } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.div `
  --gutter: ${fluid(16, 24)};

  display: flex;
  flex-wrap: wrap;
  gap: var(--gutter);

  & > * {
    width: 100%;
  }

  @media ${until(Device.TabletLarge)} {
    align-items: center;
    flex-direction: column;
  }

  @media ${from(Device.TabletLarge)} {
    justify-content: center;

    & > * {
      // prettier-ignore
      flex: 0 0 calc((100% - var(--gutter) * ${(props) => props['data-cards-per-row'] - 1}) / ${(props) => props['data-cards-per-row']})
    }
  }
`;
export const CardGridStyles = {
    Container,
};
